import script from "./record-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./record-table.vue?vue&type=script&lang=ts&setup=true"

import "./record-table.vue?vue&type=style&index=0&id=055c6efc&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-055c6efc"]])

export default __exports__